module.exports = __webpack_public_path__ + "img/photo-0048.6c24fc73.jpg";